import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Order, OrderCollection } from '@/firestore'
import store, { Mutations } from '../../../store'

@Component
export default class VendorOverviewList extends Mixins(IconsMixin, AuthMixin) {
  public orders: Order[] = []

  // alert snackbar
  showAlertSnackbar = false
  alertSnackbarMessage = ''

  public async mounted() {
    const collection = new OrderCollection((await this.$firebase).firestore())
    if (this.userClaim.admin) {
      this.orders = collection.watchOrdersByCompanyId(this.userCompany.id)
    } else {
      this.orders = collection.watchVendorOrdersByVendorRepId(this.user.uid)
    }

    if (store.state.error && store.state.error.message) {
      const errorMessage = `Error: ${store.state.error.message}`
      this.alertSnackbarMessage = errorMessage
      this.showAlertSnackbar = true

      store.commit(Mutations.UPDATE_ERROR, {error: null})
    }
  }

  public get ordersShipping() {
    if (!this.orders) {
      return 0
    }

    return this.orders.filter(order => (
      order.status === 'shipping'
    )).length
  }

  public get ordersCreated() {
    if (!this.orders) {
      return 0
    }

    return this.orders.filter(order => (
      order.status === 'created'
    )).length
  }

  public get ordersCheckedInToday() {
    if (!this.orders) {
      return 0
    }

    return this.orders.filter(order => {
      if (order.dateCheckedIn) {
        return this.isToday(order.dateCheckedIn)
      }
    }).length
  }

  public get ordersReceived() {
    if (!this.orders) {
      return 0
    }

    return this.orders.filter(order => (
      order.status === 'received'
    )).length
  }

  public isToday(date: Date) {
    const todaysDate = new Date();

    return date.getFullYear() === todaysDate.getFullYear() &&
      date.getMonth() === todaysDate.getMonth() &&
      date.getDate() === todaysDate.getDate();
  }
}
